import * as types from "../actions/actionTypes";

export const reducer = (state = { currentRowIndex: 0 }, action) => {
  switch (action.type) {
    case types.RESULT:
      return {
        ...state,
        result: action.result, //result object
      };
    case types.GET_DATA_SUCCESS:
      return {
        ...state,
        users: action.data,
      };
    case types.GET_JOB_SUCCESS:
      return {
        ...state,
        job: action.job,
      };
    case types.SET_PROFILE_INDEX:
      //increment if no param
      const profileIndex =
        typeof action.index == "number" ? action.index : state.profileIndex + 1;
      return {
        ...state,
        profileIndex,
        currentRowIndex: 0, //reset
        checkbox: null, //reset
      };
    case types.SET_USER_THUMBNAILS:
      const { userId, thumbnails } = action;
      const updatedUserIdx = state.users.findIndex(user => user._id === userId);

      const updatedUser = state.users[updatedUserIdx];
      state.users[updatedUserIdx] = { ...updatedUser, thumbnails };
      return {
        ...state,
        users: [...state.users],
      };
    default:
      return state;
  }
};
